/** FA catalog — FE-2 (copy carried/adapted from the approved handoff FA text). */
export const setupFa: Record<string, string> = {
  'common.save': 'ذخیره تغییرات',
  'common.saved': 'ذخیره شد',
  'common.view': 'دیدن',
  'common.edit': 'ویرایش',
  'common.add': 'افزودن',
  'common.remove': 'برداشتن',
  'common.enable': 'فعال کردن',
  'common.disable': 'غیرفعال کردن',
  'common.enabled': 'فعال',
  'common.disabled': 'غیرفعال',
  'common.minutes': 'دقیقه',
  'common.failedKept':
    'ذخیره انجام نشد — هیچ‌چیز از آنچه نوشتید از بین نرفت. اتصال را بررسی کنید و دوباره تلاش کنید.',
  'profile.saveRefused':
    'سامانه مرکز این ذخیره را نپذیرفت — هیچ‌چیز از آنچه نوشتید از بین نرفت. فیلدها را بررسی کنید و دوباره تلاش کنید.',
  'profile.saveFailed':
    'سامانه مرکز نتوانست ذخیره را کامل کند — هیچ‌چیز از آنچه نوشتید از بین نرفت. کمی بعد دوباره تلاش کنید.',

  'table.range': '{from}–{to}',
  'table.rangeOf': '{from}–{to} از {total}',
  'table.perPage': 'تعداد سطر در هر صفحه',
  'table.previous': 'قبلی',
  'table.next': 'بعدی',
  'table.page': 'صفحه {n}',
  'table.keptNote': 'با عوض کردن صفحه، جستجو، فیلترها و ترتیب نمایش شما همان‌طور که بود می‌ماند.',
  'table.noResultsTitle': 'چیزی پیدا نشد',
  'table.failedTitle': 'این فهرست بارگذاری نشد',
  'table.failedBody':
    'سامانه مرکز به این درخواست جواب نداد، پس هر چه نشان داده می‌شد به‌روز نبود. هیچ‌چیز در جای دیگر صفحه تغییر نکرده است.',
  'table.retry': 'تلاش دوباره',
  'table.noResultsBody':
    'املای عبارت را بررسی کنید یا جستجو را پاک کنید. هیچ‌چیزی حذف نشده — فقط چیزی با این شرایط پیدا نمی‌شود.',

  'setup.title': 'تنظیمات مرکز',
  'setup.tabProfile': 'مشخصات مرکز',
  'setup.tabStaff': 'کارکنان',
  'setup.tabRoles': 'نقش‌ها',
  'setup.tabHours': 'ساعت کاری',
  'setup.tabRooms': 'اتاق‌ها',
  'setup.tabServices': 'خدمات',
  'setup.tabCatalogs': 'فهرست بالینی',

  'profile.sub': 'هویت مرکز و تنظیمات سراسری آن — هر بخش دیگری مستقل است.',
  'profile.cardProfile': 'مشخصات مرکز',
  'profile.cardProfileMeta': 'همان‌طور که خانواده‌ها مرکز را می‌شناسند.',
  'profile.cardConfig': 'پیکربندی',
  'profile.cardConfigMeta': 'قالب تاریخ، زمان و مبالغ را برای همه افراد این مرکز تعیین می‌کند.',
  'profile.editProfile': 'ویرایش مشخصات',
  'profile.editConfig': 'ویرایش پیکربندی',
  'profile.displayName': 'نام نمایشی',
  'profile.displayNameHelp': 'این نام در پیام‌ها و صفحه‌های چاپی دیده می‌شود.',
  'profile.address': 'نشانی',
  'profile.addressHelp': 'برای خانواده‌ها و بازدیدهای خارج از مرکز استفاده می‌شود.',
  'profile.contactPhone': 'تلفن تماس',
  'profile.contactPhoneHelp': 'شماره‌ای که خانواده‌ها با آن تماس می‌گیرند.',
  'profile.contactEmail': 'ایمیل تماس',
  'profile.website': 'وب‌سایت',
  'profile.websiteHelp':
    'برای خانواده‌ها نمایش داده می‌شود. اگر https:// را ننویسید، خودش اضافه می‌شود.',
  'profile.instagram': 'اینستاگرام',
  'profile.instagramHelp': 'فقط نام کاربری، با یا بدون @. چسباندن لینک پروفایل هم کار می‌کند.',
  'profile.operatingContext': 'حوزه فعالیت',
  'profile.operatingContextHelp': 'یک یا دو خط درباره کاری که مرکز انجام می‌دهد.',
  'profile.calendar': 'تقویم',
  'profile.calendarHelp':
    'همه تاریخ‌ها در محصول با این تقویم نوشته می‌شوند. عوض کردنش نیاز به تایید دارد.',
  'profile.jalali': 'شمسی',
  'profile.gregorian': 'میلادی',
  'profile.currency': 'واحد پول',
  'profile.currencyHelp':
    'کد سه‌حرفی ISO. IRR در سراسر محصول به‌صورت تومان نشان داده می‌شود — فقط نمایش، نه ذخیره.',
  'profile.currencyInvalid': 'یک کد سه‌حرفی ISO وارد کنید، مثلا IRR.',
  'profile.timezone': 'منطقه زمانی',
  'profile.timezoneHelp': 'زمان‌ها همه‌جا از این منطقه زمانی پیروی می‌کنند.',
  'profile.buffer': 'فاصله پیش از هر جلسه',
  'profile.bufferHelp':
    'دقیقه‌هایی که پیش از هر جلسه برای درمانگر و اتاق آزاد نگه داشته می‌شود — نه برای مراجع، که ممکن است بی وقفه از جلسه‌ای به جلسه بعد برود. درمانگر یا اتاق می‌تواند مقدار خودش را داشته باشد؛ هر کدام بزرگ‌تر بود، همان اعمال می‌شود. زمان‌بندی هوشمند هم همین فاصله را رعایت می‌کند.',
  'profile.travel': 'زمان سفر پیش‌فرض',
  'profile.travelValue': '{n} دقیقه برای هر مسیر',
  'profile.travelHelp':
    'دقیقه در هر مسیر، برای نوبت‌های خانگی‌ای که زمان رفت‌وآمد خودشان خالی مانده. دقیقهٔ کامل از {min} تا {max}.',
  'profile.travelInvalid': 'دقیقه کامل بین ۰ تا ۴۸۰.',
  'profile.scheduleSms': 'پیامک برنامهٔ فردا برای درمانگرها',
  'profile.scheduleSmsNotice':
    'با روشن کردن این گزینه، هر روز عصر بین ساعت ۱۸ تا ۲۱، ساعت جلسات فردا و نام کامل مراجعان برای هر درمانگر پیامک می‌شود. فقط درمانگرهایی پیامک می‌گیرند که دست‌کم یک بار با کد پیامکی وارد پنل شده باشند.',
  'profile.confirmCalTitle': 'تقویم برای کل مرکز عوض شود؟',
  'profile.confirmCalBody':
    'همه افراد این مرکز تاریخ‌ها را با تقویم {calendar} می‌خوانند و وارد می‌کنند — در پرونده‌ها، زمان‌بندی و صفحه‌های چاپی.',
  'profile.confirmCalEffect':
    'هیچ داده ذخیره‌شده‌ای تغییر نمی‌کند — فقط نحوه نوشتن و خواندن تاریخ‌ها.',
  'profile.confirmCalCta': 'تغییر تقویم',
  'profile.readonlyNote':
    'شما فقط می‌توانید این تنظیمات را ببینید. برای تغییر آن‌ها به مجوز مدیریت نیاز دارید — به همین دلیل این صفحه دکمه‌های کمتری نشان می‌دهد و هیچ دکمه قفل‌شده‌ای ندارد.',
  'profile.saved': 'تنظیمات مرکز ذخیره شد',

  'staff.sub': 'کارکنان این مرکز. شما حساب‌ها را می‌سازید و اطلاعات ورود را خودتان تحویل می‌دهید.',
  'staff.add': 'همکار جدید',
  'staff.colMember': 'کارمند',
  'staff.colRoles': 'نقش‌ها',
  'staff.colStatus': 'وضعیت',
  'staff.colActions': 'اقدام‌ها',
  'staff.unnamed': 'کارمند بی‌نام',
  'staff.active': 'فعال',
  'staff.suspended': 'غیرفعال شده',
  'staff.admin': 'مدیر مرکز',
  'staff.noRole': 'بدون نقش',
  'staff.searchPh': 'جستجوی نام یا تلفن',
  'staff.emptyTitle': 'هنوز کارمندی نیست',
  'staff.emptyBody':
    'اولین حساب را بسازید و اطلاعات ورودش را تحویل دهید — ثبت‌نام شخصی وجود ندارد.',
  'staff.noDelete': 'حذف کارمند در محصول وجود ندارد — حساب‌ها غیرفعال و دوباره فعال می‌شوند.',
  'staff.deactivate': 'غیرفعال کردن',
  'staff.reactivate': 'فعال کردن',
  'staff.deactivateTitle': 'دسترسی {name} خاموش شود؟',
  'staff.deactivateBody':
    'او دیگر نمی‌تواند به این مرکز وارد شود. این حذف نیست و می‌توانید دوباره روشنش کنید.',
  'staff.deactivateEffectTitle': 'چه اتفاقی می‌افتد',
  'staff.deactivateEffect':
    'نوبت‌های آینده و کارهای ناتمامش به نام خودش ثبت می‌ماند؛ مراجعان همان‌جا می‌مانند. بعداً هرجا لازم بود کار را واگذار کنید.',
  'staff.reactivateTitle': 'دسترسی {name} دوباره روشن شود؟',
  'staff.reactivateBody': 'او می‌تواند با همان اطلاعات قبلی به این مرکز وارد شود.',

  'staffNew.title': 'ساختن حساب کارمند',
  'staffNew.sub':
    'شما حساب را می‌سازید، بعد اطلاعات ورود را به فرد تحویل می‌دهید. ثبت‌نام شخصی وجود ندارد.',
  'staffNew.first': 'نام',
  'staffNew.last': 'نام خانوادگی',
  'staffNew.mobile': 'شماره موبایل',
  'staffNew.mobileHelp': 'برای کدهای ورود و هویت حساب.',
  'staffNew.mobileInvalid': 'یک شماره موبایل معتبر وارد کنید، مثلا ۰۹۱۲ ۱۲۳ ۴۵۶۷.',
  'staffNew.errAlreadyMember':
    'این فرد از قبل عضو این مرکز است — چیز جدیدی ساخته نشد. نقش‌های او از صفحه خودش در فهرست کارکنان مدیریت می‌شود.',
  'staffNew.errSuspended':
    'این فرد از قبل عضو این مرکز است و فعلا معلق است. عضویت او را از فهرست کارکنان از سر بگیرید، نه با ساختن حساب جدید.',
  'staffNew.errProvisioning':
    'حسابی با این شماره موبایل هنوز در حال ساخت است. کمی بعد دوباره تلاش کنید — اگر باز هم نشد، با پشتیبانی زویار تماس بگیرید.',
  'staffNew.errDisabled':
    'حسابی با این شماره موبایل وجود دارد اما غیرفعال است. برای برگرداندنش با پشتیبانی زویار تماس بگیرید.',
  'staffNew.errNationalId':
    'این شماره موبایل مال حسابی با کد ملی دیگر است. اطلاعات فرد را بررسی کنید، یا با پشتیبانی زویار تماس بگیرید.',
  'staffNew.errRefused':
    'سامانه مرکز این اطلاعات را نپذیرفت — هر فیلد را بررسی کنید و دوباره تلاش کنید. هیچ‌چیز از آنچه نوشتید از بین نرفت.',
  'staffNew.email': 'ایمیل',
  'staffNew.emailHelp': 'برای ورود با ایمیل و رمز عبور.',
  'staffNew.role': 'نقش در این مرکز',
  'staffNew.roleHelp': 'نقش تعیین می‌کند فرد چه می‌بیند و چه کارهایی می‌تواند انجام دهد.',
  'staffNew.cta': 'ساختن حساب',
  'staffNew.pwNote':
    'شما هیچ‌وقت رمز تایپ نمی‌کنید. با ساختن حساب، یک رمز موقت ساخته می‌شود که یک‌بار در صفحه بعد نشان داده می‌شود؛ بعد از آن دیگر دیده نمی‌شود.',
  'staffNew.confirmTitle': 'این شماره موبایل از قبل حساب دارد',
  'staffNew.confirmBody': 'صاحب این شماره در زویار با این نام ثبت شده است:',
  'staffNew.confirmBodyNoName':
    'صاحب این شماره در زویار نامی ثبت نکرده است. فقط اگر مطمئنید شماره درست است ادامه دهید.',
  'staffNew.confirmYes': 'بله، همین فرد را اضافه کن',
  'staffNew.confirmNo': 'نه، شماره را اصلاح می‌کنم',
  'staffNew.existing':
    'این شماره موبایل از قبل مال یک حساب است — با نقش انتخاب‌شده به این مرکز وصل شد. رمز جدیدی برای تحویل وجود ندارد.',

  'handover.title': 'حساب ساخته شد',
  'handover.sub': 'این اطلاعات را خودتان تحویل دهید — حضوری، تلفنی، یا هر روشی که مرکز شما دارد.',
  'handover.warnOnce':
    'رمز موقت فقط همین حالا نشان داده می‌شود. بعد از ترک این صفحه دیگر دیده نمی‌شود.',
  'handover.username': 'نام کاربری',
  'handover.mobile': 'شماره موبایل',
  'handover.email': 'ایمیل ورود',
  'handover.temp': 'رمز موقت',
  'handover.copy': 'کپی',
  'handover.copied': 'کپی شد',
  'handover.firstLogin':
    'وقتی اولین بار با این رمز موقت وارد شود، از او خواسته می‌شود رمز خودش را انتخاب کند و ورود در همان مرحله کامل می‌شود.',
  'handover.done': 'تمام شد',

  'member.identity': 'هویت و ورود',
  'member.practitioner': 'اطلاعات درمانگر',
  'member.practitionerSub': 'فقط برای نقش‌هایی که جلسه ارائه می‌دهند. همه موارد اختیاری است.',
  'member.jobTitle': 'عنوان شغلی',
  'member.specialty': 'تخصص',
  'member.license': 'شماره پروانه',
  'member.experience': 'سابقه',
  'member.qualified': 'مجاز به ارزیابی',
  'member.qualifiedHelp':
    'می‌تواند ارزیابی‌های اولیه انجام دهد — تعیین می‌کند چه کسی می‌تواند ارزیابی را امضا کند.',
  'member.bio': 'معرفی کوتاه',
  'member.buffer': 'فاصله پیش از هر جلسه',
  'member.bufferHelp':
    'اگر خالی بماند، مقدار پیش‌فرض مرکز اعمال می‌شود. دقیقه‌هایی که پیش از هر جلسه این درمانگر آزاد نگه داشته می‌شود.',
  'member.maxDay': 'حداکثر جلسات در روز',
  'member.maxWeek': 'حداکثر جلسات در هفته',
  'member.rolesCard': 'نقش‌های این فرد',
  'member.extraTitle': 'مجوزهای اضافی این فرد',
  'member.extraSub':
    'نقش دست نمی‌خورد — این صفحه فقط اضافه می‌کند. برای کم کردن اختیارات فرد، نقشش را عوض کنید.',
  'member.extraAdded': 'افزوده شده',
  'perm.loading': '…',
  'perm.retired': 'مجوز بازنشسته (دیگر در فهرست نیست)',

  /* ZOY-635: the permission catalogue in the clinic manager's language — one name and one short explanation per key. */
  'perm.clinic.members.manage': 'مدیریت همکاران',
  'perm.clinic.members.manage.desc': 'همکاران را به مرکز اضافه یا از آن حذف کنید.',
  'perm.clinic.roles.manage': 'مدیریت نقش‌ها',
  'perm.clinic.roles.manage.desc':
    'نقش‌ها را بسازید، ویرایش و غیرفعال کنید و تعیین کنید هر نقش چه کاری می‌تواند انجام دهد.',
  'perm.clinic.grants.manage': 'واگذاری نقش و دسترسی',
  'perm.clinic.grants.manage.desc': 'به همکاری نقش بدهید و مجوز اضافی شخصی اضافه یا حذف کنید.',
  'perm.clinic.admin.full': 'مدیر کامل مرکز',
  'perm.clinic.admin.full.desc':
    'اختیار نامحدود در مرکز؛ فقط کارکنان زویار آن را می‌دهند و می‌گیرند.',
  'perm.clinic.families.manage': 'مدیریت ارتباط با خانواده‌ها',
  'perm.clinic.families.manage.desc':
    'خانواده‌ای را دعوت کنید، درخواست خانواده‌ای را بپذیرید یا رد کنید و ارتباطی را تمام کنید.',
  'perm.clinic.families.read': 'دیدن ارتباط با خانواده‌ها',
  'perm.clinic.families.read.desc': 'دعوت‌ها، درخواست‌ها و ارتباط‌های خانوادگی با مرکز را ببینید.',
  'perm.clinic.audit.read': 'دیدن گزارش رویدادها',
  'perm.clinic.audit.read.desc': 'ببینید چه کسی در مرکز چه کاری و چه زمانی انجام داده است.',
  'perm.clinic.settings.read': 'دیدن تنظیمات مرکز',
  'perm.clinic.settings.read.desc':
    'پروفایل و پیکربندی مرکز (تقویم، واحد پول، پیش‌فرض‌های زمان‌بندی) را ببینید.',
  'perm.clinic.settings.manage': 'تغییر تنظیمات مرکز',
  'perm.clinic.settings.manage.desc': 'پروفایل و پیکربندی مرکز را تغییر دهید؛ هر تغییر ثبت می‌شود.',
  'perm.clinic.personnel.read': 'دیدن مشخصات همکاران',
  'perm.clinic.personnel.read.desc': 'اطلاعات حرفه‌ای همکاران و درمانگران را ببینید.',
  'perm.clinic.personnel.manage': 'ویرایش مشخصات همکاران',
  'perm.clinic.personnel.manage.desc':
    'اطلاعات حرفه‌ای همکاران و درمانگران را ثبت و ویرایش کنید، از جمله مجوز ارزیابی.',
  'perm.clinic.catalog.read': 'دیدن فهرست خدمات',
  'perm.clinic.catalog.read.desc': 'خدمات و رشته‌های مرکز و فهرست‌های پایه را ببینید.',
  'perm.clinic.catalog.manage': 'مدیریت فهرست خدمات',
  'perm.clinic.catalog.manage.desc':
    'خدمات اختصاصی مرکز را اضافه کنید، خدمات را غیرفعال کنید و قیمت خدمات را تعیین کنید.',
  'perm.clinic.rooms.read': 'دیدن اتاق‌ها',
  'perm.clinic.rooms.read.desc': 'اتاق‌ها و تنظیمات زمان‌بندی آن‌ها را ببینید.',
  'perm.clinic.rooms.manage': 'مدیریت اتاق‌ها',
  'perm.clinic.rooms.manage.desc':
    'اتاق می‌سازد و ویرایش می‌کند، فعال یا غیرفعالش می‌کند و فاصلهٔ پیش از هر جلسه را تعیین می‌کند.',
  'perm.clinic.capabilities.read': 'دیدن تخصص‌ها',
  'perm.clinic.capabilities.read.desc': 'ببینید هر درمانگر و هر اتاق چه خدماتی می‌تواند ارائه دهد.',
  'perm.clinic.capabilities.manage': 'تعیین تخصص‌ها',
  'perm.clinic.capabilities.manage.desc': 'تعیین کنید هر درمانگر و هر اتاق چه خدماتی ارائه می‌دهد.',
  'perm.clinic.availability.read': 'دیدن ساعت کاری',
  'perm.clinic.availability.read.desc': 'ساعات کاری، مرخصی و مسدودی اتاق‌ها را ببینید.',
  'perm.clinic.availability.manage': 'تنظیم ساعت کاری',
  'perm.clinic.availability.manage.desc': 'ساعات کاری، مرخصی و مسدودی اتاق‌ها را تعیین کنید.',
  'perm.clinic.patients.read': 'دیدن مراجعان',
  'perm.clinic.patients.read.desc': 'پرونده‌های مراجعان را ببینید و جستجو کنید.',
  'perm.clinic.patients.register': 'ثبت مراجع',
  'perm.clinic.patients.register.desc': 'پرونده مراجع جدید بسازید و ثبت‌نامش را کامل کنید.',
  'perm.clinic.patients.update': 'اصلاح پروندهٔ مراجع',
  'perm.clinic.patients.update.desc':
    'اطلاعات هویتی مراجع را اصلاح کنید؛ مقدار قبلی در تاریخچه می‌ماند.',
  'perm.clinic.patients.contacts.read': 'دیدن همراهان مراجع',
  'perm.clinic.patients.contacts.read.desc': 'همراهان و اطلاعات تماس روی پروندهٔ مراجع را می‌بیند.',
  'perm.clinic.patients.contacts.manage': 'مدیریت همراهان مراجع',
  'perm.clinic.patients.contacts.manage.desc':
    'همراه به پرونده اضافه می‌کند، ویرایش می‌کند یا برمی‌دارد.',
  'perm.clinic.patients.duplicates.resolve': 'تصمیم دربارهٔ پرونده‌های مشابه',
  'perm.clinic.patients.duplicates.resolve.desc':
    'وقتی دو پرونده شبیه هم اند، تصمیم بگیرید آیا یک نفرند.',
  'perm.clinic.patients.history.read': 'دیدن تاریخچهٔ پرونده',
  'perm.clinic.patients.history.read.desc':
    'ببینید چه کسی پرونده‌ای را ساخته یا اصلاح کرده و درباره پرونده‌های شبیه هم چطور تصمیم گرفته شده است.',
  'perm.clinic.intake.read': 'دیدن پذیرش اولیه',
  'perm.clinic.intake.read.desc': 'پرونده‌های پذیرش مراجعان را ببینید.',
  'perm.clinic.intake.write': 'ثبت پذیرش اولیه',
  'perm.clinic.intake.write.desc': 'پرونده‌های پذیرش را بنویسید و ویرایش کنید.',
  'perm.clinic.intake.complete': 'تکمیل پذیرش اولیه',
  'perm.clinic.intake.complete.desc': 'یک پذیرش را کامل‌شده علامت بزنید.',
  'perm.clinic.assessments.read': 'دیدن ارزیابی‌ها',
  'perm.clinic.assessments.read.desc': 'ارزیابی‌ها و ارزیابی‌های مجدد را ببینید.',
  'perm.clinic.assessments.write': 'نوشتن ارزیابی',
  'perm.clinic.assessments.write.desc': 'ارزیابی‌ها و ارزیابی‌های مجدد را بنویسید و ویرایش کنید.',
  'perm.clinic.assessments.complete': 'امضای ارزیابی',
  'perm.clinic.assessments.complete.desc':
    'ارزیابی را امضا و کامل کنید. مجوز ارزیابی درمانگر جداگانه در پروفایل او تعیین می‌شود.',
  'perm.clinic.packages.read': 'دیدن بسته‌ها',
  'perm.clinic.packages.read.desc':
    'قالب‌های بسته و بسته‌های مراجعان را با قیمت‌ها و جلسات برنامه‌ریزی‌شده ببینید.',
  'perm.clinic.packages.manage': 'مدیریت بسته‌ها',
  'perm.clinic.packages.manage.desc':
    'قالب بسته بسازید و بسته مراجع را تعریف یا ویرایش کنید: ترکیب، قیمت و تخفیف.',
  'perm.clinic.bookings.read': 'دیدن نوبت‌ها',
  'perm.clinic.bookings.read.desc': 'نوبت‌ها و تقویم مرکز را می‌بیند.',
  'perm.clinic.bookings.schedule': 'ثبت نوبت',
  'perm.clinic.bookings.schedule.desc': 'برای مراجع نوبت می‌گیرد: درمانگر، اتاق و زمان.',
  'perm.clinic.bookings.reschedule': 'جابه‌جایی نوبت',
  'perm.clinic.bookings.reschedule.desc': 'زمان، درمانگر یا اتاق نوبت ثبت‌شده را عوض می‌کند.',
  'perm.clinic.bookings.cancel': 'لغو نوبت',
  'perm.clinic.bookings.cancel.desc': 'نوبت ثبت‌شده را لغو می‌کند.',
  'perm.clinic.sessions.read': 'دیدن جلسه‌ها',
  'perm.clinic.sessions.read.desc': 'جلسات برگزار شده و پیشرفت حاصل از آن‌ها را ببینید.',
  'perm.clinic.sessions.deliver': 'ثبت برگزاری جلسه',
  'perm.clinic.sessions.deliver.desc': 'یک جلسه را برگزار شده ثبت کنید — ثبت آنچه رخ داده است.',
  'perm.clinic.sessions.correct': 'اصلاح ثبت جلسه',
  'perm.clinic.sessions.correct.desc':
    'ثبت یک جلسه را باطل یا دوباره برقرار کنید؛ هر اصلاح با دلیلش در تاریخچه می‌ماند.',
  'perm.clinic.sessions.payment.record': 'ثبت پرداخت جلسه',
  'perm.clinic.sessions.payment.record.desc':
    'مبلغ، وضعیت و روش پرداخت یک جلسه را ثبت کنید. نه حسابداری، نه تسویه و نه صدور صورت حساب.',
  'perm.clinic.instruments.read': 'دیدن ابزارهای بالینی',
  'perm.clinic.instruments.read.desc':
    'پرسش‌نامه‌ها و آزمون‌های استاندارد مراجع و نتایج آن‌ها را ببینید.',
  'perm.clinic.instruments.administer': 'اجرای ابزار بالینی',
  'perm.clinic.instruments.administer.desc':
    'پرسش‌نامه یا آزمون استاندارد را برای مراجع شروع کنید و پیش‌نویس را پر کنید.',
  'perm.clinic.instruments.finalize': 'نهایی‌کردن اجرای ابزار',
  'perm.clinic.instruments.finalize.desc':
    'یک اجرا را نهایی کنید و در صورت نیاز نسخه اصلاحی صادر کنید.',
  'perm.clinic.plan.read': 'دیدن برنامهٔ درمان',
  'perm.clinic.plan.read.desc': 'طرح مراقبت مراجعانی را ببینید که ارتباط فعال با مرکز دارند.',
  'perm.clinic.plan.author': 'نوشتن برنامهٔ درمان',
  'perm.clinic.plan.author.desc':
    'طرح مراقبت و تکالیف خانگی مراجعان دارای ارتباط فعال را بنویسید و پیشرفت را ثبت کنید.',
  'field.digits': 'فقط رقم.',
  'field.whole': 'یک عدد کامل، بدون اعشار.',
  'field.range': 'بین {min, number} و {max, number}.',
  'field.fixFirst': 'اول فیلد مشخص‌شده را اصلاح کنید.',
  'member.passwordKey': 'رمز عبور',
  'member.passwordBody':
    'فرد خودش رمزش را مدیریت می‌کند: رمز موقت در اولین ورود عوض می‌شود، و رمز فراموش‌شده از صفحه ورود با ایمیل او و کدی که به موبایل ثبت‌شده‌اش پیامک می‌شود بازیابی می‌شود. هیچ‌چیزی از این‌جا تعیین نمی‌شود.',
  'member.hoursLink': 'ساعات کاری و مرخصی',
  'member.tab.profile': 'پروفایل',
  'member.tab.hours': 'ساعت کاری',
  'member.tab.timeoff': 'مرخصی',
  'member.hoursSub':
    'الگوی هفتگی تکرارشونده این فرد. یک روز می‌تواند چند بازه داشته باشد و هر بازه می‌گوید کار کجا انجام می‌شود.',
  'member.timeOffSub':
    'غیبت‌هایی که الگوی هفتگی را کنار می‌زنند. نوبت‌های داخل آن‌ها کار پیگیری پذیرش می‌شوند — چیزی خودکار لغو نمی‌شود.',
  'member.noPractitionerTitle': 'هنوز اطلاعات درمانگر ثبت‌نشده',
  'member.noPractitionerBody':
    'برنامه‌ها و مرخصی به اطلاعات درمانگر وابسته‌اند. اول آن‌ها را در تب پروفایل ذخیره کنید — عنوان شغلی کافی است.',
  'member.onlyClinic':
    'این صفحه هیچ‌چیزی درباره مرکز دیگری نشان نمی‌دهد و در آن‌جا چیزی را عوض نمی‌کند.',

  'roles.sub':
    'نقش‌ها تعیین می‌کنند فرد چه می‌بیند و چه کارهایی می‌تواند انجام دهد. مرکز شما می‌تواند نقش‌های خودش را بسازد؛ مدیریت کامل مرکز اختیار محافظت‌شده پلتفرم است.',
  'roles.create': 'نقش جدید',
  'roles.people': '{n, plural, one {# نفر} other {# نفر}}',
  'roles.inactive': 'غیرفعال',
  'roles.activeChip': 'فعال',
  'roles.lifecycle': 'وضعیت',
  'roles.deactivate': 'غیرفعال کردن این نقش',
  'roles.deactivateHint': 'غیرفعال کردن، نقش را از استفاده خارج می‌کند بدون حذف چیزی.',
  'roles.deactivateTitle': '«{name}» غیرفعال شود؟',
  'roles.deactivateBody':
    'همه کسانی که این نقش را دارند بی درنگ مجوزهایش را از دست می‌دهند. نقش‌هایی که به آن‌ها داده‌شده حفظ می‌شود — هیچ کس از مرکز حذف نمی‌شود — و فعال کردن مجدد دقیقا همان اختیارات قبلی را برمی‌گرداند.',
  'roles.deactivateEffect': 'نقش تا زمان فعال‌شدن مجدد از فهرست‌های تخصیص ناپدید می‌شود.',
  'roles.deactivateCta': 'غیرفعال کردن نقش',
  'roles.reactivate': 'فعال کردن مجدد این نقش',
  'roles.reactivateBody':
    'غیرفعال: هیچ مجوزی نمی‌دهد و قابل تخصیص نیست. فعال کردن مجدد، اختیارات دارندگانش را برمی‌گرداند.',
  'roles.inactiveNote':
    'این نقش غیرفعال است. هیچ مجوزی نمی‌دهد و قابل تخصیص نیست؛ تخصیص‌های موجود حفظ می‌شوند و فعال کردن مجدد آن‌ها را برمی‌گرداند.',
  'roles.errDuplicate':
    'نقشی با این نام از قبل در این مرکز وجود دارد — چیزی عوض نشد. نام دیگری انتخاب کنید.',
  'roles.errForbidden':
    'سامانه مرکز این تغییر را نپذیرفت. یک نقش فقط می‌تواند مجوزهایی داشته باشد که خودتان دارید.',
  'roles.errRefused':
    'سامانه مرکز این تغییر را نپذیرفت — هیچ‌چیز از آنچه نوشتید از بین نرفت. نام و مجوزها را بررسی کنید و دوباره تلاش کنید.',
  'roles.protectedTitle': 'مدیر مرکز',
  'roles.protectedBody':
    'اختیار کامل در این مرکز — مستقیم از طرف پلتفرم داده می‌شود، نه از طریق نقش. از این‌جا نمی‌توان آن را ساخت یا کم کرد.',
  'roles.protectedChip': 'محافظت‌شده',
  'roles.catalogNote':
    'فهرست مجوزها و پیش‌فرض‌ها از سامانه مرکز می‌آید — سطرهای زیر هر چه آن تعریف کند را نشان می‌دهند؛ هیچ‌چیزی از خود ساخته نمی‌شود.',
  'roles.name': 'نام نقش',
  'roles.nameHelp': 'هر چه مرکز شما آن را بنامد.',
  'roles.description': 'توضیح',
  'roles.copyFrom': 'شروع از نقش موجود',
  'roles.copyFromHelp':
    'اختیاری — مجوزهای آن نقش را به‌عنوان نقطه شروع کپی می‌کند و همچنان قابل‌ویرایش است.',
  'roles.copyNone': 'شروع خالی',
  'roles.createCta': 'ساختن نقش',
  'roles.permissions': 'مجوزها',
  'roles.affects': 'تغییر در این‌جا همه دارندگان نقش را تحت تاثیر قرار می‌دهد.',
  'roles.saveCta': 'ذخیره مجوزها',

  'hours.sub':
    'الگوی هفتگی تکرارشونده برای هر درمانگر. یک روز می‌تواند چند بازه داشته باشد و هر بازه می‌گوید کار کجا انجام می‌شود.',
  'hours.pick': 'درمانگر',
  'hours.noPractitioners':
    'هنوز کسی اطلاعات درمانگر ندارد، بنابراین برنامه‌ای برای تنظیم وجود ندارد.',
  'hours.noPractitionersLink': 'اطلاعات درمانگر را در صفحه کارکنان اضافه کنید.',
  'hours.needsPersonnel':
    'فهرست کردن درمانگران به مجوز پروفایل پرسنلی نیاز دارد. از مدیر مرکز بخواهید آن را به نقش شما اضافه کند، یا برنامه‌ای برایتان جستجو کند.',
  'hours.overlap': 'این بازه با بازه‌ای که قبلا برای این روز تعیین شده هم‌پوشانی دارد.',
  'hours.addRange': 'بازهٔ تازه',
  'hours.day': 'روز',
  'hours.from': 'از',
  'hours.to': 'تا',
  'hours.where': 'جای کار',
  'hours.inClinic': 'در مرکز',
  'hours.offSite': 'بیرون از مرکز',
  'hours.both': 'هر دو',
  'hours.online': 'آنلاین',
  'hours.modesHelp': 'همه شیوه‌هایی که درمانگر در این بازه کار می‌کند — دست‌کم یکی.',
  'hours.presetOnline': 'برای جلسه‌های آنلاین هم باز باشد',
  'hours.closed': 'بسته',
  'hours.adminOnly':
    'در نسخه اول، مدیر مرکز ساعات کاری را تعیین و مرخصی را ثبت می‌کند؛ فرایند درخواست و تایید درمانگر وجود ندارد.',
  'hours.presetsTitle': 'پر کردن هفته با یک الگوی آماده',
  'hours.presetsSub':
    'فقط یک میان‌بر. برنامه فعلی را با الگوی انتخابی جایگزین می‌کند و بعد از آن هر روز قابل‌ویرایش می‌ماند.',
  'hours.preset.all_week': 'تمام هفته',
  'hours.preset.even_days': 'روزهای زوج',
  'hours.preset.odd_days': 'روزهای فرد',
  'hours.presetEditable': 'هر روز زیر همچنان دستی قابل‌تغییر یا حذف است.',
  'hours.presetConfirmTitle': 'برنامه با «{name}» جایگزین شود؟',
  'hours.presetConfirmBody':
    '{days} · {hours} · {where}. هر یک از این روزها یک بازه می‌گیرد؛ هر روز دیگر بسته می‌شود.',
  'hours.presetReplaces':
    '{n, number} بازهٔ فعلی اول حذف می‌شود. این برگشت‌پذیر نیست، اما هر روز را می‌توان دوباره دستی تنظیم کرد.',
  'hours.presetEmptyNow': 'هنوز چیزی تنظیم نشده — الگوی آماده فقط هفته را پر می‌کند.',
  'hours.presetCta': 'جایگزینی برنامه',
  'hours.presetDone':
    'برنامه تنظیم شد: {n, number} روز، {hours}، {where}. هر روز را پایین تنظیم کنید.',
  'hours.presetPartial': 'با مشکلاتی اعمال شد — {failed}. بقیه هفته مطابق زیر تنظیم شد.',
  'hours.presetRemoveFailed': '{n, number} بازهٔ قدیمی حذف نشد',
  'hours.presetAddFailed': '{day} اضافه نشد ({reason})',
  'hours.change': 'تغییر',
  'hours.changeTitle': 'تغییر این بازه',
  'hours.changeCta': 'ذخیره تغییر',
  'hours.changed': 'بازه عوض شد.',
  'hours.changeRefused': 'چیزی عوض نشد — بازه جدید پذیرفته نشد: {reason}',
  'hours.changeRestoreFailed':
    'بازه جدید پذیرفته نشد ({reason}) و بازه قدیمی هم برنگشت. آن را دستی دوباره اضافه کنید: {old}.',
  'hours.removeFailed': 'بازه حذف نشد — چیزی عوض نشد.',
  'hours.timeOffNone': 'هیچ مرخصی ثبت‌نشده.',
  'hours.timeOff': 'مرخصی',
  'hours.recordTimeOff': 'ثبت مرخصی',
  'hours.startsDate': 'از — تاریخ',
  'hours.startsTime': 'از — ساعت',
  'hours.endsDate': 'تا — تاریخ',
  'hours.endsTime': 'تا — ساعت',
  'hours.offOrder': 'پایان باید بعد از شروع باشد — تاریخ‌ها و ساعت‌ها را بررسی کنید.',
  'hours.reason': 'دلیل',
  'hours.reasonHelp': 'اختیاری، و فقط مدیران مرکز آن را می‌بینند.',
  'hours.timeOffNote':
    'مرخصی همیشه ذخیره می‌شود. نوبت‌های داخل آن کار پیگیری پذیرش می‌شوند — چیزی خودکار لغو نمی‌شود.',
  'hours.saveCta': 'ذخیره مرخصی',
  'hours.timeFormat': 'زمان ۲۴ ساعته، مثلا ۱۴:۳۰',

  'rooms.sub': 'اتاق‌های واقعی مرکز، و این‌که هر کدام چه خدمات درون مرکزی می‌تواند میزبانی کند.',
  'rooms.add': 'اتاق جدید',
  'rooms.colRoom': 'اتاق',
  'rooms.colType': 'نوع',
  'rooms.colStatus': 'وضعیت',
  'rooms.noCode': 'بدون کد',
  'rooms.noType': 'بدون نوع',
  'rooms.noDelete':
    'اتاقی که استفاده نمی‌شود غیرفعال می‌شود؛ نوبت‌های گذشته‌اش دست‌نخورده می‌ماند. حذف در محصول وجود ندارد.',
  'rooms.name': 'نام',
  'rooms.code': 'کد',
  'rooms.codeHelp': 'کوتاه، برای تقویم و برای این‌که کارکنان چطور از آن حرف می‌زنند.',
  'rooms.type': 'نوع اتاق',
  'rooms.typeHelp': 'متن آزاد — هر چه مرکز شما این نوع اتاق را می‌نامد.',
  'rooms.buffer': 'فاصله پیش از هر جلسه',
  'rooms.bufferHelp':
    'اگر خالی بماند، مقدار پیش‌فرض مرکز اعمال می‌شود. وقتی جلسه‌ای در این اتاق رزرو می‌شود، بزرگ‌تر از این مقدار و فاصله درمانگر پیش از آن آزاد نگه داشته می‌شود.',
  'rooms.description': 'توضیح',
  'rooms.available': 'قابل استفاده برای نوبت',
  'rooms.availableHelp':
    'خاموش کردن، نوبت‌های گذشته را عوض نمی‌کند؛ نوبت آیندهٔ تازه در آن گذاشته نمی‌شود.',
  'rooms.supported': 'خدمت‌های پشتیبانی‌شده',
  'rooms.supportedHelp':
    'فقط خدمات درون مرکزی این‌جا مهم‌اند — خدمات آنلاین و در محل مراجع هیچ‌وقت اتاق نمی‌گیرند.',
  'rooms.createCta': 'ساختن اتاق',
  'rooms.emptyTitle': 'هنوز اتاقی نیست',
  'rooms.emptyBody':
    'اتاق‌هایی را اضافه کنید که جلسات در آن‌ها برگزار می‌شود. تناسب با خدمات برای هر اتاق جداگانه تعیین می‌شود.',
  // ZOY-636: room hours and blockouts (availability.manage, not rooms.manage).
  'rooms.hoursTitle': 'ساعات',
  'rooms.hoursSub':
    'اگر خالی بماند، اتاق هر وقت مرکز نوبت بگیرد باز است. ساعت را فقط برای بستن اتاق بیرون از آن تنظیم کنید؛ توانایی، مسدودی و کلید قابل‌رزرو همیشه اعمال می‌شوند.',
  'rooms.hoursOpen': 'ساعتی تنظیم نشده — باز بر اساس ساعات.',
  'rooms.hoursNeedManage': 'تغییر ساعات یا مسدودی‌های اتاق به مجوز مدیریت دسترسی نیاز دارد.',
  'rooms.blockoutsTitle': 'مسدودی‌ها',
  'rooms.blockoutsSub':
    'اتاقی که مدتی بسته است — تعمیر، رویداد، نگهداری. نوبت‌های داخل آن رد می‌شوند.',
  'rooms.blockoutsNone': 'هیچ مسدودی ثبت‌نشده.',
  'rooms.recordBlockout': 'ثبت مسدودی',
  'rooms.blockoutCta': 'ذخیره مسدودی',
  'rooms.blockoutNote':
    'مسدودی همیشه ذخیره می‌شود. نوبت‌های داخل آن کار پیگیری پذیرش می‌شوند — چیزی خودکار لغو نمی‌شود.',

  'svc.sub':
    'آنچه مرکز ارائه می‌دهد: فهرست پلتفرم به‌علاوه خدماتی که این مرکز ساخته است. آنچه این‌جا فعال است همان چیزی است که تقویم می‌تواند رزرو کند.',
  'svc.add': 'خدمت تازه',
  'svc.colService': 'خدمت',
  'svc.colLocation': 'شیوه ارائه',
  'svc.colPrice': 'قیمت',
  'svc.colDuration': 'مدت پیش‌فرض',
  'svc.colStatus': 'وضعیت',
  'svc.durationNote': 'یک پیشنهاد، نه مقدار ثابت',
  'svc.platform': 'فهرست زویار',
  'svc.clinicMade': 'ساخته‌شده توسط این مرکز',
  'svc.disabledHere': 'غیرفعال در این مرکز',
  'svc.loc.in_clinic': 'در مرکز',
  'svc.loc.off_site': 'بیرون از مرکز',
  'svc.loc.both': 'در مرکز و خارج از آن',
  // ZOY-237: the mode set replaces the single designation.
  'svc.mode.in_clinic': 'در مرکز',
  'svc.mode.off_site': 'در خانه',
  'svc.mode.online': 'آنلاین',
  'svc.modesNeeded': 'دست‌کم یک شیوه ارائه را فعال کنید.',
  'svc.groupCapacity': 'ظرفیت پیش‌فرض گروه',
  'svc.groupCapacityHelp':
    'فرم جلسه گروهی جدید را پیش‌پر می‌کند؛ تا ۲۰ در مرکز، ۱۵ آنلاین. خالی بگذارید تا در هر جلسه تعیین شود.',
  'svc.groupNote':
    'خدمت گروهی به‌صورت یک جلسه با چند شرکت‌کننده اجرا می‌شود که از تقویم به‌عنوان جلسه گروهی ساخته می‌شود.',
  'svc.name': 'نام',
  'svc.description': 'توضیح',
  'svc.descriptionHelp': 'برای فهرست و فرم نوبت؛ کوتاه و به زبان خانواده.',
  'svc.price': 'قیمت',
  'svc.priceHelp': 'یک واقعیت ثبت‌شده برای بسته‌ها و سوابق پرداخت — نه یک سامانه پرداخت.',
  'svc.duration': 'مدت پیش‌فرض',
  'svc.durationHelp': 'فرم نوبت را پیش‌پر می‌کند؛ هر نوبت می‌تواند کوتاه‌تر یا بلندتر باشد.',
  'svc.location': 'شیوه ارائه',
  'svc.locationHelp':
    'همه شیوه‌هایی که می‌توان این خدمت را در آن‌ها رزرو کرد — دست‌کم یکی. خدمت گروهی در مرکز یا آنلاین است، هیچ‌وقت در محل مراجع.',
  'svc.createCta': 'ساختن خدمت',
  'svc.oneSwitchNote':
    'یک کنترل وضعیت: «در این مرکز فعال». خاموش‌کردن رزرو تازه را می‌بندد و چیزی از موجودها لغو نمی‌کند.',
  'svc.editGapNote':
    'ویرایش نام و توضیحات خدمت در انتظار تصمیم درباره هویت فهرست در سامانه مرکز است — فیلدها تا آن زمان فقط‌خواندنی‌اند.',
  'svc.practitioners': 'درمانگران',
  'svc.practitionersSub':
    'قابلیت همان مجوز است: بدون آن، درمانگر هیچ‌وقت برای این خدمت پیشنهاد نمی‌شود. «تطبیق» و «ترجیح» فقط ترتیب پیشنهادهای زمان‌بندی هوشمند را تعیین می‌کنند.',
  'svc.rooms': 'اتاق‌ها',
  'svc.roomsSub': 'اتاق فقط وقتی مهم است که جلسه در مرکز باشد.',
  'svc.rankNote': 'فقط ترتیب — نه مجوز',
  'svc.preferred': 'ترجیحی',
  'svc.match': 'تطبیق {n}',
  'svc.grant': 'افزودن درمانگر',
  'svc.removeCapTitle': 'این قابلیت حذف شود؟',
  'svc.removeCapBody':
    'هیچ نوبت موجودی لغو نمی‌شود — اما اگر نوبت آینده‌ای بعداً جابه‌جا شود، این درمانگر شاید دیگر پیشنهاد نشود.',
  'svc.removeRoomTitle': 'پشتیبانی این اتاق حذف شود؟',
  'svc.removeRoomBody':
    'هیچ نوبت موجودی لغو نمی‌شود — نوبت در-مرکزِ آینده در این اتاق شاید هنگام جابه‌جایی اتاق دیگری بخواهد.',
  'svc.supports': 'پشتیبانی می‌کند',
  'svc.notSetUp': 'برای آن تنظیم نشده',
  'svc.emptyTitle': 'هنوز خدمتی نیست',
  'svc.emptyBody':
    'فهرست پلتفرم بعد از مقداردهی اولیه این‌جا نشان داده می‌شود؛ مرکز می‌تواند خدمات خودش را هم بسازد.',

  'cat.sub':
    'واژگان بالینی مشترک: پایه پلتفرم به‌علاوه افزوده‌های این مرکز. غیرفعال کردن در سطح مرکز است و یک مورد را فقط از استفاده جدید پنهان می‌کند.',
  'cat.medications': 'داروها',
  'cat.historyItems': 'موارد تاریخچه',
  'cat.add': 'افزودن',
  'cat.category': 'دسته',
  'cat.categoryHelp': 'گروه‌بندی، مثلا تولد، رشدی، پزشکی.',
  'cat.name': 'نام',
  'cat.emptyTitle': 'هنوز چیزی این‌جا نیست',
  'cat.emptyBody':
    'موارد پایه پلتفرم بعد از مقداردهی اولیه نشان داده می‌شوند؛ افزوده‌های مرکز این‌جا ساخته می‌شوند.',
  /* دسته‌بندی بالینی خدمت (ZOY-542/550). */
  'svc.workflow': 'مدل ورک فلو',
  'svc.workflowHelp':
    'معنای بالینی استاندارد این خدمت. یک‌بار انتخاب می‌شود و بعد از آن هیچ‌وقت قابل‌ویرایش نیست — خدمتی که اشتباه دسته‌بندی شده با یک مورد جدید جایگزین می‌شود، نه اصلاح.',
  'svc.workflowNeeded': 'اول مدل گردش‌کار را انتخاب کنید.',
  'svc.wf.assessment': 'ارزیابی',
  'svc.wf.speech_therapy_session': 'جلسه گفتاردرمانی',
  'svc.wf.occupational_therapy_session': 'جلسه کاردرمانی',
  'svc.wf.consultation': 'مشاوره',
  'svc.wf.virtual_reality_session': 'واقعیت مجازی (VR)',
  'svc.wf.neurotherapy_session': 'عصب درمانی',
  'svc.wf.group_session': 'جلسه گروهی',
  'svc.wf.unclassified': 'دسته‌بندی نشده',
  'svc.createFailed': 'خدمت ساخته نشد — چیزی ذخیره نشد. فیلدها را بررسی کنید و دوباره تلاش کنید.',
  /* فهرست‌های بالینی — بازطراحی پذیرش (ZOY-574) */
  'cat.complaints': 'شکایات',
  'cat.section': 'بخش',
  'cat.sectionHelp': 'کدام بخش پذیرش این مورد را ارائه می‌دهد.',
  'cat.medPlatformNote':
    'فهرست داروها توسط پلتفرم مدیریت می‌شود. کلینیک شما می‌تواند سطری را این‌جا پنهان یا نشان دهد، اما نمی‌تواند سطری اضافه کند — داروی خارج از فهرست با نام در خود پذیرش وارد می‌شود.',
  'cat.archived': 'بایگانی‌شده',
  'cat.createFailed': 'مورد اضافه نشد — چیزی ذخیره نشد. فیلدها را بررسی کنید و دوباره تلاش کنید.',
  // ZOY-776: extra-charge kinds.
  'setup.tabExtraCharges': 'اقلام و هزینه‌های اضافه',
  'xk.sub':
    'آنچه پذیرش می‌تواند علاوه بر جلسه دریافت کند: مشاوره خانواده به ازای هر ۱۵ دقیقه، یک ابزار آموزشی، یک وقت اضافه. فهرست خالی، کنترل را هنگام پرداخت پنهان می‌کند. انواع خاموش می‌شوند، هیچ‌وقت حذف نمی‌شوند.',
  'xk.name': 'نام',
  'xk.pricing': 'قیمت‌گذاری',
  'xk.pricing.time': 'بر اساس زمان — نرخ هر ۱۵ دقیقه',
  'xk.pricing.fixed': 'مبلغ ثابت با پیش‌فرض',
  'xk.pricing.free': 'مبلغ آزاد — هر بار وارد می‌شود',
  'xk.unitTime': 'نرخ هر ۱۵ دقیقه',
  'xk.unitFixed': 'مبلغ پیش‌فرض',
  'xk.counts': 'جزو زمان کاری درمانگر',
  'xk.countsHelp': 'دقیقه‌های این نوع در گزارش مدیریت به زمان کار درمانگر اضافه می‌شود.',
  'xk.sortOrder': 'ترتیب در فهرست',
  'xk.add': 'افزودن نوع',
  'xk.emptyTitle': 'هنوز نوعی نیست',
  'xk.emptyBody': 'اولین نوع را اضافه کنید تا هنگام پرداخت جلسه، «افزودن هزینه اضافی» ظاهر شود.',
  'xk.disabled': 'خاموش',
  'xk.enable': 'روشن کردن',
  'xk.disable': 'خاموش کردن',
  'xk.edit': 'ویرایش',
  'xk.saveFailed': 'ذخیره نشد — چیزی عوض نشد. فیلدها را بررسی کنید و دوباره تلاش کنید.',
  'xk.errUnit': 'انواع زمانی و ثابت به مبلغی بزرگ‌تر از صفر نیاز دارند؛ نوع آزاد مبلغی ندارد.',
  'xk.pricingLocked':
    'مدل قیمت‌گذاری بعد از ساخت قابل‌تغییر نیست؛ نرخ و نام قابل تغییرند — هزینه‌های قبلی مبلغ خودشان را حفظ می‌کنند.',
  'xk.countsOn': 'بله',
  'xk.countsOff': 'خیر',
};
